var _style, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFatalError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3000 2250",
    style: {
      enableBackground: "new 0 0 3000 2250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#EBF2FF;}\n\t.st2{fill:#003188;}\n\t.st3{fill:#FFDFAB;}\n\t.st4{fill:none;stroke:#003188;stroke-width:7;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:#003188;stroke:#003188;stroke-width:7;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#FF8500;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#FF8500;stroke-width:6;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 3000,
    height: 2250
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "shadow"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1198.3,691.6c-14.9,21.6,45.4,64.1,57,27.8C1262.2,697.9,1216.8,664.8,1198.3,691.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1355.5,733.1c16.3,20.6,21.7-6.1,32.9-42.4C1369.8,677.7,1335.3,707.5,1355.5,733.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1295.6,805.7c29.1,0,33.2-27.2,2.6-27.8C1273,777.4,1263.2,805.7,1295.6,805.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M885.6,1000.1c11-16.2,52.1-77,36.8-99.8c-12.8-19-57.4-4.4-73.2,0.6c-74.9,23.7-128.2,87.1-167.1,152.3 c-22.4,37.5-74,88.4-9.8,82.6C756.7,1128,839,1068.5,885.6,1000.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M675.9,1530.4c-31.7-18-66.6-30.2-102.7-35.2c-42.7-6-51.2-8.1-54.3,30.8c-4.9,61.4,16.3,136,78.4,160 c34.4,13.3,144.4,16,168.4-22.4C797.4,1613,709.9,1549.6,675.9,1530.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1047.7,1179.4c-11.9,1.5-13.7,196-16,220c-1.4,14-15.5,63,0.4,68.5c11.2,3.9,44.8-28.3,48.8-35.5 c24.6-44,20.4-127.3,24.1-176.6c1.2-15.4,13.4-88.8,2.4-99.6C1089.4,1138.6,1066.5,1177,1047.7,1179.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M977.8,1003.3c26.6,0,98.8-61,56-71.6C1000.2,923.4,938.5,1003.3,977.8,1003.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1180.1,980.5c50.6,27.3,137.6,22.6,168-33.3c43.4-79.7-75.5-8.2-100.2-7.4c-28.3,1-56.7-9.2-78.2-27.6 c-7.9-6.8-25.9-41.2-37.2-42.5C1069.2,862.7,1162.9,971.3,1180.1,980.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1188.6,1188.3c-37.5-23.5-71.2,110.3-24.1,115.2C1206.5,1307.9,1219,1207.3,1188.6,1188.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1497.1,996.2c20.7,19.1,104,91.2,138.1,75.4c30-13.9-30.7-92.4-44.3-106.4c-24.2-25-76.5-55.9-140.7-56.6 C1415,925.1,1482,982.3,1497.1,996.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1690,1707c-64.9,0-129.8,0-194.7,0c-38.7,0-77.4,0-116,0c-9.2,0-56.8-2-31.1,16c9.3,6.5,49.8,0,60.3,0 c42.8,0,85.6,0,128.4,0c40.7,0,81.3,0,122,0c6.2,0,23.4,3.3,28.9,0C1692.2,1720.3,1707.2,1707,1690,1707z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M583.2,1733.8c-18.9,1.4-57.3-12.2-73-1.9c-29.2,19.1,10.6,13,24.4,13.5c16.9,0.6,32.6,6.9,50,4.2 c4-0.6,7.2,8.1,10.5,6.5C613,1747.9,596.8,1733.8,583.2,1733.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M646.8,1724.9c-22.8-4.1-32.6,20.3-13.5,16.7C638.3,1740.6,667.2,1728.5,646.8,1724.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M543.1,1655.8c0-14.3-129.5-14.9-129.5,0C413.5,1670.7,543.1,1670,543.1,1655.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M760.5,1739c-13.8-8.3-39,4.9-18.5,13.8C749.6,1756.2,776,1748.3,760.5,1739z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1707.5,1648.4c-3.6,0-7.1,0-10.7,0c31.4-34.8-6.1-101-22.7-134.3c-13.7-27.5-56.1-124.7-98-118 c-83.2,13.2,31.7,225,62.2,252.3c-65.8-0.1-131.5-0.2-197.3-0.4c56.4-72.6-148.5-77.2-175-74.7c-49,4.6-96.2,19.2-145,24.7 c-51.8,5.9-100.7-8.4-152.2-9.5c-17.5-0.4-202.3,37.3-145.7,74.4c10,6.5,46.9,0.1,58.3,0.1c217.6,0.4,435.1,0.8,652.7,1.2 c44.9,0.1,89.8,0.2,134.7,0.2c7.8,0,26.5,3.7,33.5,0.1C1706.5,1662.2,1729.9,1648.5,1707.5,1648.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1220.8,1708.3c24.3-15.1-51.4-30.5-47.1-7C1175.6,1711.9,1215.5,1711.6,1220.8,1708.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M962.4,1714.1c-17.4-8.8-26.3-4-44.1-6.2c-14.6-1.8-37.7-12.8-52.1-9.9c-7.6,1.5-30.7,4.1-20.7,17.1 c5.3,6.8,18.2-2.1,24.6-1.1c19.9,3.1,39.3,5.7,58.9,8.5C932.1,1723,985.7,1726,962.4,1714.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1024,1709.4c-13.3-4.6-44.9,4.8-21.7,13.6C1014,1727.5,1042.2,1715.7,1024,1709.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1242.8,1759c-11.7-2.2-45.3,11-21.4,18.9C1235,1782.4,1260,1761.7,1242.8,1759z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1903.3,1354.5c-54,125.5-108,251-162,376.5c156,0,312,0,468,0c44.7,0,89.4,0,134.2,0c20.8,0,59.6,7.7,79.2,0 c32.5-12.7,53-101.3,67.3-134.6c34.7-80.6,69.4-161.2,104.1-241.9C2363.8,1354.5,2133.6,1354.5,1903.3,1354.5z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "cup"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1635,1343.5c-5,11.5-46.1,8.8-97.2-13.4c-23.7-10.3-44.7-22.8-59.2-35.1c-13.1-11.1-19.4-21.2-17-26.8v0 c1.9-4.3,9.1-6.6,19.9-6.6c3.4,0,7.2,0.2,11.2,0.7c18.9,2.1,42.4,9,66.1,19.3C1609.9,1303.7,1640,1332,1635,1343.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1632.5,1354.3C1632.5,1354.3,1632.5,1354.3,1632.5,1354.3c-4.5,1.8-10.3,2.8-17.4,2.8 c-3.7,0-7.7-0.2-12-0.7c-19.6-2.2-43.8-9.2-68.1-19.8c-24.3-10.6-46-23.4-61-36.2c-9.8-8.4-16.1-16.1-18.6-22.9l-59.2,209.4 c0,0,0,0,0,0c-3.3,7.5,21.8,25.6,56.1,40.5c34.2,14.8,64.6,20.8,67.9,13.3l0,0L1632.5,1354.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1635,1343.5c-5,11.5-46.1,8.8-97.2-13.4c-23.7-10.3-44.7-22.8-59.2-35.1c-13.1-11.1-19.4-21.2-17-26.8 L1635,1343.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1396.5,1432c-3.7,0-7.4-1.6-9.9-4.8c-14.3-18.3-26.6-35.1-32.6-54.9c-7.6-25.3-1.2-50.5,16.4-64.1 c8.7-6.8,19.4-10.2,30-9.6c12.7,0.6,24.5,7,30.8,16.7c3.8,5.8,2.2,13.5-3.6,17.3c-5.8,3.8-13.5,2.2-17.3-3.6 c-1.9-2.9-6.6-5.2-11.1-5.4c-4.6-0.2-9.5,1.4-13.4,4.4c-7.1,5.5-13.4,18.5-7.8,37.1c4.7,15.7,15.7,30.5,28.4,46.7 c4.3,5.4,3.3,13.3-2.1,17.5C1401.9,1431.1,1399.2,1432,1396.5,1432z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1399.7,1301.7c-16,1.5-29.9,10.8-36.7,25.4c-7.3,15.5-5.6,33,2.1,47.9c1.8,3.4,6.9,0.4,5.2-3 c-6.7-13-8.3-28.4-2.1-41.9c5.9-12.6,17.7-21.1,31.6-22.4C1403.5,1307.3,1403.6,1301.3,1399.7,1301.7L1399.7,1301.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1369.9,1385.1c0,0,0.2,0.2,0.2,0.1C1370.1,1385.3,1369.5,1384.8,1369.9,1385.1c0.2,0.2-0.3-0.5-0.2-0.3 C1369.8,1385,1369.8,1385.1,1369.9,1385.1c-0.1-0.2-0.2-0.4-0.3-0.7c0.1,0.2,0.1,0.4,0.2,0.6c0-0.3-0.1-0.5-0.1-0.8 c0,0.1,0,0.2,0,0.3c0.1,1.6,1.3,3.1,3,3c1.6-0.1,3.1-1.3,3-3c-0.1-1.9-1-3.7-2.7-4.6c-1.4-0.7-3.3-0.4-4.1,1.1 C1368.1,1382.4,1368.4,1384.3,1369.9,1385.1L1369.9,1385.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1412.5,1495.3c25.8,19.8,56.4,32.6,88.5,37.1c3.8,0.5,5.4-5.3,1.6-5.8c-31.7-4.4-61.7-17-87.1-36.5 C1412.5,1487.8,1409.5,1493,1412.5,1495.3L1412.5,1495.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1472.9,1319.3c27,19.2,57,33.8,88.8,43.3c3.7,1.1,5.3-4.7,1.6-5.8c-31.3-9.3-60.7-23.7-87.3-42.7 C1472.7,1311.9,1469.7,1317.1,1472.9,1319.3L1472.9,1319.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1572.8,1365.5c2.4,0.4,4.8,0.9,7.3,1.3c1.6,0.3,3.2-0.4,3.7-2.1c0.4-1.4-0.5-3.4-2.1-3.7 c-2.4-0.4-4.8-0.9-7.3-1.3c-1.6-0.3-3.2,0.4-3.7,2.1C1570.3,1363.3,1571.2,1365.2,1572.8,1365.5L1572.8,1365.5z"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "color_shadow"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1938.9,1072.3c-10.3-7.1-24.3-0.8-34.9,5.9c-10.6,6.7-23.5,14.1-34.8,8.7c0,0,0,0-0.1,0 c-13.8-6.6-13.5-26.5-7.9-40.7c13.3-34.1,43.7-60.2,53.1-95.6c0.9-3.6,1.6-7.5,1.7-11.3c-9-4.2-20.9-1.2-29.2,5 c-17.5,13-24.6,36.4-41.5,50.2c-18,14.7-43.8,15.9-63.1,28.9c-22.3,15.1-31.7,42.8-38.5,68.8c-6.7,26-13,53.9-31.9,73 c-32.3,32.6-87.8,26.8-125.6,52.9c-19.8,13.7-31.8,35.1-39.3,57.6c-1.5,4.4-16.1,51.5-11.2,53.7c0,0,25.5,11.5,48.6,16.6 c8.8,2,7.2-13.1,13.3-18.6c15.3-14.1,37.1-23.9,55.7-26.1c27.6-3.2,55.5,1.9,83.4,1.9c24.6,0,49.4-4.1,71.9-14.1 c9.8-4.3,19.6-10.2,24.8-19.7c1.3-2.3,2.1-4.9,2.6-7.5c1.4-8.1-1.1-16.9-8-21.2c-2.2-1.4-4.8-2.2-7.4-3.1 c-5.3-1.7-10.7-3.1-13.2-7.7c-2.5-4.6-0.8-10.4,1.6-15.1c11.4-21.9,35.7-33.1,57-45.5c23.5-13.7,45.2-30.5,64.3-49.8 c6.4-6.6,12.8-13.7,15.4-22.5c0.4-1.3,0.7-2.6,0.9-3.9C1947.7,1085.3,1945.3,1076.7,1938.9,1072.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1616.1,1137.2c2.5,1.5,7,0.8,8.2-2.2c2.9-7,6.5-13.6,10.6-20c4.2-6.5-6.1-12.5-10.4-6.1 c-4.1,6.3-7.7,13-10.6,20C1612.7,1132,1613,1135.4,1616.1,1137.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2001.2,867.2c1.2,2.7-4.5,9.6-6,11.5c-2.7,3.7-6,6.9-9.5,9.9c-5.9,5,2.6,13.4,8.5,8.5 c9.4-8,23-22.7,17.4-35.9C2008.5,854.1,1998.2,860.2,2001.2,867.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1990.3,922.8c-1.2,4.9-3,9.3-5.7,13.6c-4.1,6.6,6.3,12.6,10.4,6.1c3.2-5.1,5.5-10.6,6.9-16.5 C2003.7,918.5,1992.1,915.3,1990.3,922.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2112.1,976.7c-14.8,10.4-31,17.9-48.5,22.3c-7.5,1.9-4.3,13.5,3.2,11.6c18.4-4.6,35.9-12.6,51.4-23.5 C2124.4,982.6,2118.4,972.2,2112.1,976.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1709.8,1369.2c-9.5-1-17.6-5.9-23.6-13.1c-4.9-6-13.4,2.6-8.5,8.5c8.1,9.8,19.6,15.4,32.1,16.6 C1717.5,1382,1717.5,1370,1709.8,1369.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1223.7,531.7c-45.2,8.2-68.5,51.9-83,91c-1.7,4.6,2.3,7.5,6.1,7.2c1.3,1.8,3.4,2.9,6.1,2.5 c3.7-0.6,10.1-2,13,1.3c2.6,2.9-0.7,8.8-1.3,12.2c-1.7,9.1-1.2,18.2,1.5,27c1.4,4.5,6.7,5.7,10,2.6c17.3-15.6,25.2-40.1,33-61.3 c9.1-24.5,16.3-49.7,21.9-75.3C1232.1,534.3,1228.3,530.8,1223.7,531.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1409.7,512.7c-11.4-10.2-26.6-15.7-41.3-18.9c-27.8-5.9-62.3-7.6-88.4,6.3c-1.1-0.1-2.4,0.1-3.6,0.8 c-12.6,7.5-24.8,17.8-28.6,32.6c-3.5,13.8,1.2,27.6,13.2,35.5c11.2,7.4,25.8,9.1,38.8,11.1c15.1,2.3,30.4,3.9,45.7,3.4 c14.5-0.5,29.2-2.8,42.7-8.4c12.4-5.1,26.5-12.8,32.3-25.5C1426.5,536.2,1420.1,522,1409.7,512.7z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "outline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1159.2,630.7c-6.4-2.7-14.1-1.6-20,2.2s-10,9.9-12.1,16.6c-2.9,9.2-2,19.5,2.3,28.2 c4.4,8.6,12.2,15.4,21.3,18.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1142.3,655.9c5.5,3.3,10,8.2,12.8,13.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1155.8,715.6c-0.7,52.7-2.3,73.9-9.4,126.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1248.1,624.8c11.5-8.8,27.6-11.1,41.1-5.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1308.8,716.7c7.8,0.3,15.5-4.8,18.3-12.1c3.2-8.3,0.4-17.5-1.4-26.1c-3.8-19-2.2-39,4.7-57.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1331,621c14.2-6.4,31.1-6.6,45.5-0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1263.6,663.3c-1.3,4.1-2,8.3-2,12.6c0,0.9,0.2,2,1.1,2.1c0.8,0.1,1.4-0.8,1.6-1.7c1.2-4,1.6-8.4,0.9-12.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1349.9,667.8c-1.4,3.9-2.1,8.1-1.9,12.2c0,0.7,0.5,1.8,1.2,1.5c0.3-0.1,0.5-0.4,0.6-0.7 c1.9-3.9,2.4-8.4,1.5-12.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1318.4,735.9c-9.2-1.7-19.1-1.1-27.8,1.9c-4.9,1.7-9.7,4.2-12,8.1c-2.3,3.8-1.5,9.1,2.9,11.5 c3.1,1.7,7.2,1.7,11,1.5c6.3-0.4,12.6-1.1,18.8-2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1301.1,610.2c0,1.6,0,3.2,0,4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1396.2,604.3c-3.3,51.6-12.6,102.8-27.7,152.3c-8.9,29-22.3,60.3-50.1,72.6c-19.6,8.7-43.1,5.6-62-4.4 s-33.9-26.4-46.1-44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1343.3,812.3c-2.4,34.7-1.7,34.8-5.7,69.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1214.4,787.7c6.6,21.2,17.5,41.6,34.5,56s40.5,21.9,62,16.3c9.3-2.4,18-7.4,23.9-14.9 c5.9-7.5,8.6-17.8,5.9-27c-12.4,15-33.4,21.2-52.7,19.2c-19.4-2-37.4-11.2-53.1-22.7c-5.3-3.9-10.9-8.8-11.6-15.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1127.3,860.3c-64.4,5.5-128.5,13.7-192.2,24.4c-58.7,9.9-119.4,23.1-166.1,60 c-36.3,28.7-60.9,69.3-83.3,109.7c-68.3,123.4-123.4,254.6-156.5,391.8c-9,37.3-16.4,75.6-13.4,113.8s17.4,76.9,46,102.5 c34,30.4,83.9,38.1,128.7,29.7c44.8-8.4,85.7-31,124.1-55.5c93.6-59.8,178-132.6,262.1-205.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1104.5,1130.5c4.7,108.4-3.7,217.3-25.1,323.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1077.8,1161.3c-67.2,50.2-134.3,100.3-201.5,150.5c-32.8,24.5-66.3,49.7-89.5,83.4 c-2.8,4.1-5.4,9.7-2.3,13.6c1.5,1.9,3.9,2.7,6.3,3c14.3,1.8,26-10.6,34.7-22.1c46.3-60.9,84.9-127.6,114.9-198"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M972.3,984.6c17-13.8,35.2-26.2,54.3-37.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M672,1188.7c-32.6,59.2-55.4,123.7-67.3,190.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M649.2,1280.5c-7.3,19.6-12,40.2-13.7,61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1109.2,1176.7c36.8-26.3,59.7-53.7,83.4-92.3c2.7-4.4,5.4-8.9,9.3-12.2c4-3.3,9.6-5.1,14.4-3.2 c8.3,3.4,9,14.7,7.4,23.5c-4.2,24-15.5,52.8-26.7,73.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1317.1,1199.7c-20,23.3-44.9,42.3-72.6,55.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1217.7,1228.6c-3.3-0.1-6.5,1.2-8.9,3.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1221,1249.8c-1.7,1.9-4.1,3.2-6.7,3.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1315,1176.7c-20.7,18.8-43.5,35.3-67.8,49.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1101.5,1391.7c30.5-35.6,68.1-65,109.9-86.1c17.4-8.8,35.6-16.2,52.4-26.2c25-14.9,46.5-35.7,62.3-60.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1186.3,1175.3c23.4-12.4,46.7-24.9,70.1-37.3c13.9-7.4,27.9-14.9,41.1-23.4c17.6-11.3,34.5-24.8,55-29.7 c3.9-0.9,9.1-0.9,10.5,2.7c0.6,1.5,0.3,3.2-0.2,4.7c-1.6,5.8-4.8,11.1-8.2,16.1c-28.8,42.6-76.3,69.2-122.1,94.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1135.6,871c19.3,33.3,56.2,57.1,96.5,62.1c40.3,5.1,82.9-8.7,111.6-36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1118.8,901.6c19.7,38,61.8,65.1,107.3,69.2c45.6,4.1,93-14.9,121.2-48.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1262.2,878.1c-0.6,6.8-5.2,13.8-6.2,15.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1358.7,892.1c61.7,21.9,133.6,9.8,190.8,41.6c45,24.9,72.2,72.3,95.2,118.3c12.8,25.6,24.9,51.4,36.4,77.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1765.1,1325.1c18.7,31.9,34.9,65.3,48.3,99.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1453.1,1557c-0.6,32.2-7.3,64.2-19.7,93.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1337.3,1620.2c21.3-9.6,41.2-22.5,58.5-38.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1385,1610.8c-6.4,3.3-12.3,7.6-17.4,12.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1243.9,1597.9c1.6,0.6,3.1,1.1,4.7,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M975.3,1596.1c32.8,17.4,68.6,29.2,105.4,34.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1053.6,1596.6c7.4,3.2,14.8,6.3,22.2,9.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1069.8,1206.5c-5,75.4-16.9,150.3-35.6,223.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M900.6,1230.3c1.6-15.6,2.1-31.4,1.6-47.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1575.6,1542.3c20.7,41.6,36,69.2,60.2,108.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1618.9,1552.6c8,13,15.2,26.6,21.6,40.7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1441,750c14.8-0.6,29.6-1.5,44.4-2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1436.7,775.3c12.8,5.8,25.3,12.3,37.4,19.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M852.7,1708.1c14.4-8.2,33.1-8.1,47.3,0.3c3.4,2,6.8,4.5,10.7,5c3.5,0.4,7-0.9,10.4-1.8 c13.5-3.6,28.4-1.3,40.1,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M999.9,1712.1c5.4,0.8,10.9,1.6,16.3,2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1179.4,1697.9c10-6.1,23.5-5.8,33.2,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M506.3,1735.6c8.1-6.4,19.4-8.5,29.2-5.5c5.3,1.6,10.2,4.7,15.6,5.2c4.5,0.5,8.9-0.7,13.4-1.2 c9.7-1,19.7,1.9,27.5,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M628.1,1733.6c4.3-2.2,9.3-3,14-2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M733.3,1747.3c5.5-0.1,10.9-0.1,16.4-0.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1219.4,1765.1c6.7-0.6,13.4-1.3,20.1-1.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2607,1311 1865.5,1311 1692.3,1728.7 2433.8,1728.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "1692.3,1728.7 1341.4,1728.7 1341.4,1702 1703.4,1702  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 2190.3,
    cy: 1519.9,
    r: 33
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 821.3,
    y1: 1652.1,
    x2: 1703.4,
    y2: 1652.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 523.5,
    y1: 1652.1,
    x2: 425.3,
    y2: 1652.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1641.8,961.6c-4.5,2.3-4.5,9.6,0,11.9c2.5,1.3,5.2,0.6,6.7-1.8c1.5-2.4,1-5.5-1.4-7c-3.3-2-6.3,3.1-3,5.2 c-0.6-0.4-0.6-0.9-0.6-1.5c0,0.1,0,0.2-0.1,0.3c0.1-0.3,0.1-0.3,0-0.1c-0.3,0.1,0.1-0.1,0.2-0.2c0.2-0.1,0.3-0.2,0.6-0.2 c0.2,0,0.4,0,0.6,0.1c0.4,0.1,0.5,0.2,0.3,0c0,0-0.6-0.2-0.3-0.1c0.2,0.1-0.3-0.3,0,0c-0.1-0.2-0.2-0.3-0.1,0 c-0.1-0.2-0.1-0.4-0.2-0.5c0.1,0.5,0-0.4,0-0.6c0,0.3,0,0.2,0.1,0c0.3-0.7-0.2,0.2,0.1-0.2c0.3-0.3-0.3,0.2,0,0 c0.4-0.3-0.6,0.3,0.2-0.1c1.4-0.7,1.9-2.8,1.1-4.1C1645.1,961.2,1643.3,960.9,1641.8,961.6L1641.8,961.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M482.9,1359c0.1,3.2,1.5,6.7,4.5,8.2c2.9,1.4,6.8,0.5,8.6-2.3c1.8-2.9,0.5-6.5-2.7-7.7 c-2.8-1-6.1,0.1-6.9,3.2c1.2-0.7,2.5-1.4,3.7-2.1c-4.3-1-5.9,4.5-2.8,6.9c1.6,1.2,3.8,0.9,5.2-0.5c1.3-1.2,1.6-3.2,1.7-4.9 c0.1-3.9-5.9-3.9-6,0c0,0.1,0,0.7-0.1,0.7c0,0.1-0.1,0.2-0.1,0.4c0.2-0.3,0.4-0.6,0.7-0.8c0.5,0,1.1,0,1.6,0 c1.2,0.2,1.6,1.8,1,2.7c-0.4,0.4-0.7,0.7-1.1,1.1c-0.1,0.1-0.3,0.1-0.4,0.2c-0.5,0-1.1,0-1.6,0c0.1,0,0.1,0,0.2,0.1 c1.6,0.4,3.3-0.5,3.7-2.1c-0.2,0.6-0.8,0.6-1.1,0.8c0.1-0.1,0.4,0.1,0.1,0c0.3,0.1,0.2,0.2,0.1,0c-0.2-0.3-0.2-0.8-0.4-1.1 c-0.2-0.2,1-0.1-0.2,0.1c-0.5,0-0.6,0.2-1-0.3c-0.6-0.7-0.8-1.6-0.8-2.5C488.8,1355.1,482.8,1355.1,482.9,1359L482.9,1359z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M750.3,1507.7c-0.6,0.9-1.2,1.8-1.8,2.7c-0.9,1.3-0.3,3.4,1.1,4.1c1.5,0.8,3.2,0.3,4.1-1.1 c0.6-0.9,1.2-1.8,1.8-2.7c0.9-1.3,0.3-3.4-1.1-4.1C752.9,1505.8,751.3,1506.3,750.3,1507.7L750.3,1507.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1993,1267.1c-1.9-1.6-4.3-1.9-6.5-0.7c-1.9,1-3.3,3-3.2,5.2c0.1,1.6,1.3,3.1,3,3c1.5-0.1,3.1-1.3,3-3 c0-0.2,0.1-0.8,0,0c0.1-0.6-0.3,0.5,0,0c-0.2,0.3-0.3,0.3,0,0.1c0.2-0.1-0.5,0.3,0.1,0c0.2-0.1,0.1-0.1-0.3,0.1 c0.1,0,0.1,0,0.2-0.1c0.7,0.1-0.7-0.2,0,0c0.6,0.1-0.6-0.2,0,0c-0.1-0.1-0.2-0.1-0.4-0.2c0.3,0.2,0.2,0.1-0.1-0.1 c1.2,1,3.1,1.3,4.2,0C1994,1270.2,1994.3,1268.1,1993,1267.1L1993,1267.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M922.4,827.5c-2.7,0-4.3,2.7-3.6,5.1c0.7,2.3,3.5,4.1,5.7,2.5c-0.5,0.1-1,0.3-1.5,0.4 c1.6-0.1,2.9-0.9,3.6-2.4c0.5-1.2,0.4-2.4-0.1-3.6c-0.4-1-1.1-1.9-2-2.4c-1.6-0.9-3.3-0.5-4.6,0.7c0.4-0.3,0.9-0.5,1.3-0.8 c-1.9,0.7-3.1,2.3-3.1,4.4c0,2,1.3,3.8,3.2,4.3c1.9,0.6,4.1-0.5,5-2.3c0.9-1.7,0.8-4.1-0.8-5.4c-0.6-0.5-1.3-0.9-2.1-0.9 c-0.7,0-1.6,0.3-2.1,0.9c-1,1.1-1.3,3.2,0,4.2c0.1,0,0.1,0.1,0.2,0.2c-0.3-0.3-0.5-0.6-0.5-0.9c0.1,0.4,0-0.9,0-0.2 c0.1-0.6,0.1-0.7,0.1-0.4c-0.1,0.3,0,0.2,0.2-0.4c-0.2,0.3-0.5,0.6,0.1-0.1c-0.2,0.2-0.1,0.1,0.3-0.2c-0.3,0.2-0.1,0.1,0.4-0.2 c-0.4,0.1,0.8,0,0.3,0c0.7,0,1,0.2,1.4,0.6c-0.3-0.3,0.5,0.8,0.2,0.2c0.2,0.6,0.3,0.7,0.2,0.4c-0.1-0.3,0-0.1,0.1,0.5 c0-0.1,0-0.2,0-0.2c0-0.3,0-0.2-0.1,0.5c0.1-0.3,0.3-0.4-0.2,0.3c0.1-0.3,0.1-0.1-0.3,0.3c0.2-0.2,0.1-0.1-0.4,0.3 c0.3-0.1,0.1-0.1-0.4,0.2c0.5-0.1,0.9-0.4,1.3-0.8c-0.5,0.3-0.6,0.4-0.4,0.3c-0.6,0.2-0.8,0.3-0.5,0.2c-0.6,0.2-1.1,0.1-1.8-0.2 c0.5,0.3-0.5-0.5-0.3-0.3c0.3,0.3,0.1,0.3-0.2-0.3c0,0.1,0.1,0.2,0.2,0.3c0.2,0.4-0.3-0.9-0.1-0.3c0.2,0.6,0-0.8,0-0.4 c0,0.4-0.1,0.5,0.1-0.4c-0.1,0.4,0.4-0.8,0.2-0.4c0.3-0.5,0.7-0.9,1.4-1c-0.3,0.1-0.1,0.1,0.5-0.1c-0.3,0-0.6,0-0.9,0.1 c-0.3,0.1-0.6,0.2-0.8,0.4c-0.3,0.1-0.1,0.1,0.5-0.2c0.4-0.1,0.9-0.1,1.3,0c0.6,0.3,0.8,0.4,0.5,0.2c0.5,0.4,0.6,0.5,0.4,0.3 c0.1,0.2,0.2,0.3,0.4,0.5c0,0-0.1-0.1-0.1-0.1c-0.1-0.3-0.1-0.1,0.2,0.5c0-0.1-0.1-0.3-0.1-0.4c0.1,0.7,0.1,0.8,0.1,0.5 c0-0.3,0-0.1-0.1,0.5c0.1-0.3,0-0.1-0.2,0.5c0.1-0.2,0-0.1-0.3,0.4c-0.3,0.3-0.7,0.5-1.1,0.6c-0.7,0.1-0.8,0.1-0.5,0.1 c1.6,0,3.1-1.4,3-3C925.4,828.9,924.1,827.6,922.4,827.5L922.4,827.5z"
  })))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "color_outline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1527,1319.2c-0.5-23.1,1.1-46.6,8.3-68.6s20.2-42.6,39.2-55.8c37.7-26.1,93.2-20.4,125.6-52.9 c19-19.1,25.2-46.9,32-73c6.7-26,16.2-53.8,38.5-68.8c19.3-13,45.1-14.2,63.1-28.9c16.9-13.8,24-37.2,41.5-50.2 c9.8-7.3,24.7-10.1,33.8-1.9c8.2,7.4,8.1,20.4,5.2,31.1c-9.4,35.4-39.8,61.5-53.1,95.6c-5.5,14.2-5.8,34.1,7.9,40.7 c11.3,5.4,24.3-2,34.9-8.7c10.6-6.7,24.6-13,34.9-5.9c7.6,5.2,9.5,16,6.8,24.8c-2.7,8.8-9,15.9-15.4,22.5 c-19.1,19.4-40.8,36.2-64.3,49.8c-21.4,12.4-45.7,23.6-57,45.5c-2.4,4.7-4.1,10.4-1.6,15.1c3.8,7,13.8,6.7,20.6,10.8 c9.2,5.6,10.5,19.3,5.4,28.7c-5.1,9.4-15,15.3-24.8,19.7c-22.5,10-47.3,14.1-72,14.1c-27.8,0-55.7-5.1-83.4-1.9 s-55.5,17.3-65.7,43.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1632.6,1108.4c-2.5-4.7-7.7-1.7-10.5,0.9c-5.4,4.7-9.9,13.6-10.6,20.7c-0.2,2-0.1,4.3,1.4,5.6 c1.5,1.3,3.8,1,5.6,0.4c9.5-3.3,14.6-14.2,14.7-24.3C1633.2,1110.6,1633.1,1109.4,1632.6,1108.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M2004.6,859.1c-3.1-2.2-7.2-2.4-11.8,1c-7.8,5.8-12.6,20.7-10.1,30c4.2,15.9,23.7-5.5,26.5-12.4 C2011.9,871.1,2009.5,862.5,2004.6,859.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1998,924.4c-6.1-8.5-18,13.3-11.2,18c6.2,4.2,14.4-12.4,11.7-17.2C1998.4,924.9,1998.2,924.6,1998,924.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M2112.5,975.3c-13.9-4.9-39.3,8.3-46.3,18.9c-6.2,9.4-0.6,13,8.6,11.9c12.1-1.4,24.3-4.9,35.2-10.4 c7.6-3.9,15.6-13.4,4.7-19.5C2114,975.9,2113.2,975.5,2112.5,975.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1682.7,1367.6c5.6,7.3,14.7,11.9,24,12c1.2,0,2.4,0,3.5-0.5c4.2-1.8,3.9-8.2,1.3-12 c-3.9-5.6-10.5-8.4-16.8-10.8c-4.7-1.8-11.1-2.9-13.9,1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1133,631.6c-7.6-34.5,22.8-110.7,91-107.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1233.2,528c-0.3,55.8-23.1,111.1-62.2,150.9c-0.8,0.8-1.6,1.6-2.7,1.8c-2.9,0.5-4.2-3.4-4.4-6.3 c-1.1-19.3-0.1-38.7,3.2-57.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1207.5,565.8c-2.1,24.4-10.6,48.3-24.5,68.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1188.1,565.8c-1.5,4.6-3.1,9.1-4.6,13.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1179.6,482.8c15,4.4,28.8,13.1,39.1,24.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1216.1,477.1c5.1,6,8.7,13.2,10.3,20.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1238,516.4c66.5-63.1,161.7-38.8,196.5,15.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1239.1,577.7c14.3,5.3,29.2,9.1,44.3,11.4c26.1,4,53,3.5,78.4-3.7c25.4-7.2,49.1-21.2,66-41.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1353.1,601.4c34.7,1.8,70-13.1,92.8-39.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1286.7,565.7c40.4,2.1,81.3-12.8,110.9-40.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1299.8,548.4c11.3-3.5,22.1-8.6,31.9-15.2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFatalError);
export default __webpack_public_path__ + "static/media/Fatal Error.d2715b0b9ed451e024509f303897b649.svg";
export { ForwardRef as ReactComponent };